import clsx from "clsx";
import { IconProps } from "@/types/icons";
import { createColorClasses } from "@/theme/colors";

export const Favourite = ({
  width = 24,
  height = 24,
  className,
  color = "primary",
  filled,
  decorative = false,
  ariaLabel = "Favorite",
  onClick,
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 24 24"
      className={clsx(className, classes, onClick ? "cursor-pointer" : "")}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
      onClick={onClick}
    >
      {filled ? (
        <path d="M12 1.7l2.5 7.5h7.9L16 13.9l2.4 7.6-6.4-4.7-6.4 4.7L8 13.9 1.6 9.2h7.9z" />
      ) : (
        <path
          fillRule="evenodd"
          d="M9.5 9.2 12 1.7l2.5 7.5h7.9L16 13.9l2.4 7.6-6.4-4.7-6.4 4.7L8 13.9 1.6 9.2zm4 .3L12 4.9l-1.5 4.6-.2.7H4.6l4 2.9.6.4-.2.7-1.5 4.7 3.9-2.9.6-.4.6.4 3.9 2.9-1.5-4.7-.2-.7.6-.4 4-2.9h-5.7z"
          clipRule="evenodd"
        />
      )}
    </svg>
  );
};
